<mat-toolbar><img height="100%" src="{{logo}}"><span class="cris_item" routerLink="" >Tribal Cultural Resource Information System</span>
  <span class="fill-remaining-space"></span>
  <span><button mat-mini-fab [routerLink]="['/reports']" matTooltip="Reports"><mat-icon>description</mat-icon></button></span>
</mat-toolbar>
<div class="main-content">
  <router-outlet></router-outlet>
</div>
